import { render, staticRenderFns } from "./PublicationMunMehDataModal.vue?vue&type=template&id=36a42384&"
import script from "./PublicationMunMehDataModal.vue?vue&type=script&lang=js&"
export * from "./PublicationMunMehDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VFileInput,VOverlay,VProgressCircular})
